import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {withStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import {ContextConsumer} from '../Context'

const styles = theme => ({
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  button: {
    marginRight: 20,
  },
})

class SiteIds extends Component {
  state = {
    anchorEl: null,
  }

  handleClick = event => {
    this.setState({anchorEl: event.currentTarget})
  }

  handleClose = () => {
    this.setState({anchorEl: null})
  }
  render() {
    const {anchorEl} = this.state
    const {classes} = this.props

    return (
      <ContextConsumer>
        {context => {
          return (
            <div className={classes.button}>
              <Button
                variant="raised"
                color="secondary"
                onClick={this.handleClick}
                disabled={context.isMobile}>
                <FormattedMessage
                  id="siteId"
                  values={{
                    id: context.siteId,
                  }}
                />
                <ArrowDownIcon className={classes.rightIcon} />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}>
                {context.availableSiteIds.map(x => (
                  <MenuItem
                    key={x}
                    onClick={() => {
                      context.handleSetSiteId(x)
                      this.handleClose()
                    }}>
                    {x}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          )
        }}
      </ContextConsumer>
    )
  }
}

SiteIds.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(SiteIds)



// WEBPACK FOOTER //
// ./src/components/SiteIds.js